import BotType from '../enums/BotType';
import GlobalStoreService from '../services/global-store.service';
import UtilService from '../services/util.service'
import ActionHandlerService2 from './actions-handler.service2';
import GLOBAL_CONFIG from '../config/config';
import ActionsCommonService from './actions-common.service';
import { SCRIPTS } from '../constants/staticScripts';

export default class BotSwitchService {

    static getWhichBot(chatResponse) {
        // try {
        //     const scenarioLob = chatResponse.scenario.scenarioLob ?
        //         chatResponse.scenario.scenarioLob : GlobalStoreService.get("currentBotType");
        //     switch (scenarioLob.toUpperCase()) {
        //         case BotType.POSTPAID:
        //             return _handlePostpaidBot(chatResponse);
        //         case BotType.PREPAID:
        //             return _handlePrepaidBot(chatResponse, GlobalStoreService.get("scenarioList")[BotType.PREPAID]);
        //     }
        //     return currentBotType;
        // } catch (e) {
        //     return currentBotType;
        // }
    }
    static handleBotSwitch(result, chatItem, resolve, reject, query, retry_count) {
        //check if logged in user

        let newBotType = result.scenario.scenarioLob

        if (BotSwitchService.checkIfLobEnabled(newBotType)) {

            if (GlobalStoreService.get('isUserLoggedIn')) {

                if (GlobalStoreService.get('userProfile')) {
                    let userProfile = GlobalStoreService.get('userProfile')

                    let accounts = getAccountsForBotType(userProfile, newBotType)
                    if (accounts && accounts.length > 0) {
                        resolve({
                            message_objects: [{
                                component_type: 'SWITCH_ACCOUNT_MESSAGE',
                                message: newBotType.toLowerCase(),
                                messageTime: UtilService.getCurrentTime()
                            }]
                        })
                    }
                    else {
                        //no new bot type number in user profile
                        resolve({
                            message_objects: [{
                                component_type: 'DEFAULT',
                                message: `Hey!! You have enquired about a ${newBotType && newBotType.toLowerCase()} number, currently no ${newBotType && newBotType.toLowerCase()} numbers are added into your profile.`,
                                messageTime: UtilService.getCurrentTime()
                            }]
                        })
                    }
                }
                else {
                    // no user profile found
                    GlobalStoreService.set('isUserLoggedIn', false)
                    GlobalStoreService.set('loggedInToken', null)
                    GlobalStoreService.set('currentBotType', result.scenario.scenarioLob.toUpperCase())
                    ActionHandlerService2.executeChatOut(query, resolve, reject, retry_count, query)

                }
            }
            else {
                // handle if logged out
                GlobalStoreService.set('currentBotType', result.scenario.scenarioLob.toUpperCase())
                ActionHandlerService2.executeChatOut(query, resolve, reject, retry_count, query)
            }
        }
        else {

            resolve({ message_objects: BotSwitchService.getChatMessageIfBotLobDisabled(result, newBotType) })

        }
    }

    static checkIfLobEnabled = (newBotType) => {
        if (GLOBAL_CONFIG.lob_list.includes(newBotType.toUpperCase())) {
            return true
        }
        return false
    }

    static getChatMessageIfBotLobDisabled = (result, newBotType) => {
        // console.log(result)
        let message
        if (result && (result.searchReply)) {
            message = ActionsCommonService.getPlatformSpecificSearchReply(result) || SCRIPTS.LOB_SPECIFIC_NO_RESOLUTION_VOC.replace('{LOB}', newBotType.toLowerCase().charAt(0).toUpperCase() + newBotType.toLowerCase().slice(1))
        }
        else {
            message = SCRIPTS.LOB_SPECIFIC_NO_RESOLUTION_VOC.replace('{LOB}', newBotType.toLowerCase().charAt(0).toUpperCase() + newBotType.toLowerCase().slice(1))
        }
        // console.log(message)
        return [{
            component_type: 'DEFAULT',
            message: message,
            messageTime: UtilService.getCurrentTime()
        }]
    }

}





const getAccountsForBotType = (userProfile, BotType) => {
    let botTypeAccounts = []
    BotType = BotType.toUpperCase()
    if (userProfile && userProfile.products && userProfile.products[BotType]) {
        botTypeAccounts = userProfile.products[BotType]
    }
    return botTypeAccounts

}


const _handlePostpaidBot = (chatResponse) => {
    return BotType.POSTPAID;
}

const _handlePrepaidBot = (chatResponse, welcomeConfig) => {
    if (
        chatResponse.scenario.scenarioId === welcomeConfig["NO_INTENT_FOUND_1"]["scenarioId"]
    ) {
        return BotType.POSTPAID;
    }
    return BotType.PREPAID;
}


// WEBPACK FOOTER //
// ./src/services/bot-switch.service.js